var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions.define_BaseLayer = function (in_implements, in_extends, options) {
    var implements = [];
    var extend = OCS.Viewer.Classes.AbstractLayer;
    if (options) {
        if (options.has_legend) {
            implements.combine([new Class(OCS.Viewer.Interfaces.LayerLegend)]);
        }
        if (options.background_draw) {
            implements.combine([new Class(OCS.Viewer.Interfaces.LayerBackground)]);
        }
    }
    if (in_implements && in_implements.length) {
        implements.combine(in_implements);
    }

    if (in_extends) {
        extend = in_extends;
    }
    var obj = new Class({
        Extends: extend,
        Implements: implements,
        debug: false,
        class_name: "BaseLayer",
        style_manager: null,
        legend_events_registered: false,
        drawing_in_background: false,
        drawn: true,
        opt_index: [],
        layer_group: null,
        source: null,
        options: {
            resolution: 3,
            title: 'Default Title',
            useRetina: false,
            timestamp: null,
            timestamp_epoch: null,
            group_id: null,
            source_type: 'Vector',
            drawn_string: 'drawn',
            drawing_in_background_string: 'drawing_in_background'
        },
        degrees_to_radians: Math.PI / 180,
        miles_in_lon: {},
        /*
         * 
         * Action methods
         * 
         */
        init_events: function () {

        },
        mouse_over_legend: function (e) {

        },
        handle_mouse_over: function () {

        },
        handle_mouse_click: function () {

        },
        display_legend_tooltip: function (mouse_position) {

        },

        /*
         * Boolean test methods
         */

        is_auto: function () {
            var source = this.get_source_obj();
            if (source) {
                return source.get_auto();
            }
        },
        is_drawing_in_background: function () {
            return this.drawing_in_background;
        },
        is_drawn: function () {
            return this.drawn;
        },

        layer_has_data: function () {
            if (this.source_obj || (this.get_ol_object().features && this.get_ol_object().features.length) || this.get_ol_object().data) {
                return true;
            } else {
                return false;
            }

        },

        /*
         * 
         * Getter and Setter methods
         * 
         */
        get_source_type: function () {
            return this.options.source_type;
        },
        get_group_id: function () {
            return this.options.group_id;
        },
        get_timestamp_epoch: function () {
            return this.options.timestamp_epoch;
        },
        set_timestamp_epoch: function (active_timestamp) {
            this.options.timestamp_epoch = active_timestamp;
        },
        get_legend_events_registered: function () {
            return this.legend_events_registered;
        },
        set_legend_events_registered: function (cond) {
            this.legend_events_registered = cond;
        },

        set_drawn: function (val) {
            this.drawn = val;
        },
        set_layer_source: function () {
            var layer = this.get_ol_object();
            if (layer) {
                layer.setSource(this.get_source());
            }
        },
        get_layer_source: function () {
            var layer = this.get_ol_object();
            if (layer) {
                return layer.getSource();
            }
        },
        get_source: function () {
            if (this.source_obj) {
                return this.source_obj.get_source();
            }
        },
        get_source_obj: function () {
            return this.source_obj;
        },
        set_source_obj: function (source) {
            // Verify the incoming source is what we are expecting
            if (source && source.class_type === "Source" && source.get_timestamp_epoch() === this.get_timestamp_epoch()) {
                this.source_obj = source;
                this.set_layer_source();
                if (this.source_obj.ready) {
                    this.ready();
                } else {
                    this.source_obj.addEvent('ready', this.ready.bind(this));
                }

            }
        },

        /*
         * Delete and destroy methods
         */

        delete: function () {
            if (this.source_obj) {
                this.source_obj.destroy();
                this.source_obj = null;
            }
            this.parent();
        }
    });
    if (options && options.has_legend) {
        obj.has_legend = true;
    }
    return obj;
};
OCS.Viewer.Classes.BaseLayer = OCS.Viewer.Functions.define_BaseLayer();
